var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderbucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sub_bucket_1",
    "data-name": "Sub bucket 1",
    transform: "translate(-1120 -169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2958",
    "data-name": "Rectangle 2958",
    transform: "translate(1120 169)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_34067",
    "data-name": "Path 34067",
    transform: "translate(1121 172.328)",
    fill: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    opacity: 0.499
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.234-.328H7.307L8.782.754l1.242.827h6.592A1.234,1.234,0,0,1,17.85,2.815l.02,9.866a1.234,1.234,0,0,1-1.234,1.234H1.234A1.234,1.234,0,0,1,0,12.681V.906A1.234,1.234,0,0,1,1.234-.328Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.499996185302734 1.171935081481934 L 1.499996185302734 12.41581439971924 L 16.36927604675293 12.41581439971924 L 16.35052871704102 3.080904960632324 L 10.02338600158691 3.080904960632324 C 9.727445602416992 3.080904960632324 9.438125610351562 2.993364334106445 9.191825866699219 2.829304695129395 L 7.950056076049805 2.002164840698242 C 7.931216239929199 1.989614486694336 7.912666320800781 1.976644515991211 7.894415855407715 1.963254928588867 L 6.815637588500977 1.171935081481934 L 1.499996185302734 1.171935081481934 M 1.234355926513672 -0.3280649185180664 L 7.306796073913574 -0.3280649185180664 L 8.7816162109375 0.7537651062011719 L 10.02338600158691 1.580904960632324 L 16.61564636230469 1.580904960632324 C 17.29735565185547 1.580904960632324 17.84999656677246 2.133544921875 17.84999656677246 2.815255165100098 L 17.86981582641602 12.6814546585083 C 17.86981582641602 13.36317443847656 17.31716537475586 13.91581439971924 16.63545608520508 13.91581439971924 L 1.234355926513672 13.91581439971924 C 0.5526351928710938 13.91581439971924 -3.814697265625e-06 13.36317443847656 -3.814697265625e-06 12.6814546585083 L -3.814697265625e-06 0.9062843322753906 C -3.814697265625e-06 0.2245750427246094 0.5526351928710938 -0.3280649185180664 1.234355926513672 -0.3280649185180664 Z",
    stroke: "none",
    fill: "#3d3d3d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderbucket);
export default __webpack_public_path__ + "static/media/folderbucket.1e89128b9927907d28d57bc4dd5146d1.svg";
export { ForwardRef as ReactComponent };